import { Flex } from '@approvalmax/ui/src/components';
import { arrayHelpers } from '@approvalmax/utils';
import { memo, useMemo } from 'react';

import { useBudgets } from '../../../../hooks/useBudgets';
import { BudgetListItem } from '../BudgetListItem/BudgetListItem';
import { budgetComparator } from './BudgetList.helpers';

export const BudgetList = memo(() => {
    const { data } = useBudgets();

    const budgets = useMemo(() => arrayHelpers.arraySort(data, budgetComparator), [data]);

    if (!data || !budgets.length) return null;

    return (
        <Flex container aria-label='List of budgets'>
            {budgets.map((budget) => (
                <BudgetListItem key={budget.id} budget={budget} />
            ))}
        </Flex>
    );
});

BudgetList.displayName = 'BudgetList';
